<template>
	<div class="join-chat">
		<template v-if="waitingForJoin">
			<Loader/>
		</template>
		<template v-else>
            <h2>Deltag i chat/samtale</h2>
			<p class="mb50">Indsæt en nøgle for at deltage i chatten</p>
			<div class="form-wrap">
				<input type="text" placeholder="Skriv chat nøgle her" v-model="chatAlias" @keyup.enter="attemptJoin" />
				<button @click="attemptJoin">Deltag</button>
			</div>
		</template>
	</div>
</template>

<script>
	import Loader from "@/components/Loader";
	export default {
		components: {Loader},
		data(){
			return {
				chatAlias: '',
				waitingForJoin: false
			}
		},
		methods: {
			attemptJoin(){
				const localAlias = this.chatAlias.trim().toLowerCase();
				if(localAlias !== '')
				{
					const that = this;
					this.waitingForJoin = true;
					const key = this.$vorbasseSocket.onCommand('connected-to-room',(response) => {
						this.$vorbasseSocket.dropCommandListener('connected-to-room',key);
						if(typeof response.result !== 'undefined' && response.result > 400)
						{
							that.waitingForJoin = false;
							that.$store.dispatch('vorbasse/showPrompt',{
								title: 'Deltagelse fejlede',
								prompt: 'Rummet kunne forbindes til, check dine indtastninger og prøv igen.',
								confirmText: 'Ok - forstået',
								showCancelButton: false
							});
						}
						else
						{
							this.$vorbasseSocket.emit('open-room',response.data);
						}
					});
					this.$vorbasseSocket.emit('connect-to-room-alias',localAlias);
				}
				else
				{
					this.$store.dispatch('vorbasse/showPrompt',{
						title: 'Fejl',
						prompt: 'Du skal indtaste en chat nøgle.',
						confirmText: 'Ok - forstået',
						showCancelButton: false
					});
				}
			}
		}
	};
</script>

<style scoped>

</style>
